import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Icon from './Icon';

const PageSizeDropdown = ({ value, onChange, options = [10, 20, 50, 100], position = 'bottom' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const isTop = position === 'top';

  return (
    <div className={`pager-size-dropdown ${isTop ? 'is-top' : ''}`} ref={dropdownRef}>
      <button 
        type="button" 
        className="orders-pager-size custom-pager-btn hover-trigger" 
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{value}</span>
        <motion.div 
          animate={{ 
            rotate: isTop 
              ? (isOpen ? 0 : 180) 
              : (isOpen ? 180 : 0) 
          }} 
          transition={{ duration: 0.2 }} 
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <Icon name="chevron-down" size={14} />
        </motion.div>
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ 
              opacity: 0, 
              y: isTop ? 15 : -15, 
              x: "-50%", 
              scale: 0.9, 
              filter: "blur(5px)" 
            }}
            animate={{ 
              opacity: 1, 
              y: 0, 
              x: "-50%", 
              scale: 1, 
              filter: "blur(0px)" 
            }}
            exit={{ 
              opacity: 0, 
              y: isTop ? 10 : -10, 
              x: "-50%", 
              scale: 0.9, 
              filter: "blur(4px)", 
              transition: { duration: 0.15, ease: "easeIn" } 
            }}
            transition={{ type: "spring", stiffness: 450, damping: 25, mass: 0.8 }}
            className={`pager-size-menu ${isTop ? 'menu-down' : 'menu-up'}`}
            style={{ transformOrigin: isTop ? 'top center' : 'bottom center' }}
          >
            {options.map((opt) => (
              <button
                key={opt}
                type="button"
                className={`pager-size-option ${opt === parseInt(value, 10) ? 'active' : ''}`}
                onClick={() => {
                  onChange(opt);
                  setIsOpen(false);
                }}
              >
                {opt}
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default PageSizeDropdown;
